import { generateClient } from "aws-amplify/api";
import { listTableauViews } from "../graphql/queries";
import { fetchUserAttributes } from "aws-amplify/auth";

const client = generateClient();

// Fetch views for the current user
export const getViewsByEmail = async () => {
  try {
    const attributes = await fetchUserAttributes();
    const cognitoEmail = attributes.email;

    // Primary query: use exact Cognito email (handles existing mixed-case records)
    const response = await client.graphql({
      query: listTableauViews,
      variables: {
        filter: {
          userEmail: {
            eq: cognitoEmail,
          },
        },
      },
    });

    let items = response.data.listTableauViews.items;

    // Fallback: try lowercase (handles records stored lowercase after the fix)
    if (items.length === 0 && cognitoEmail !== cognitoEmail.toLowerCase()) {
      const lowerResponse = await client.graphql({
        query: listTableauViews,
        variables: {
          filter: {
            userEmail: {
              eq: cognitoEmail.toLowerCase(),
            },
          },
        },
      });
      items = lowerResponse.data.listTableauViews.items;
    }

    return items;
  } catch (error) {
    console.error("Error fetching views by email:", error);
    return [];
  }
};
